import CustomModal from '../../../../../../components/Modal/CustomModal';
import CustomTable from '../../../../../../components/table/CustomTable';
import React from 'react';
import WorkShiftsTableApp from '../Components/WorkShiftsTableApp';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const WorkShifts = (
    {
        show, onHide, workShift
    }
) => {

    const { tableId, searchId, thead, tbody, pagination, page, setPage, rowsPerPage, setRowsPerPage } = WorkShiftsTableApp({
        workShift
    });

    return (
        <CustomModal
            title={'work_shifts'}
            show={show}
            onHide={() => {
                onHide();
            }}
            cancelButton={false}
            confirmButton={false}
            classNameBody="p-0 m-0"
        >
            <>
                <div className='col-12'>
                    <CustomTable
                        tableId={tableId}
                        searchId={searchId}
                        thead={thead}
                        tbody={tbody}
                        columnActions={false}
                        inModal={true}
                    />
                </div>
                {pagination()}
            </>
        </CustomModal>
    );

}

export default WorkShifts
